// extracted by mini-css-extract-plugin
export var infoSection = "_j-1";
export var infoSectionContainer = "_j-0";
export var infoSectionTitleRow = "_j-2";
export var multiLineInfo = "_j-4";
export var strong = "_j-3";